import { Dispatch } from 'redux';

import { Api } from '../../../api';
import { AppState } from '../../../store/models/app-state';

export const DECLINE_DEMAND = 'DECLINE_DEMAND';

export const declineDemand = (demandAccountId: number, declineReason: string) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const demand = getState().demands.detail.demand;

        if (demand) {
            dispatch({ type: DECLINE_DEMAND });
            await api.demand.DemandOverview.decline(demand.id, demandAccountId, declineReason);
        }
    };
};
